<template>
	<div class="layout-profile">
		<div>
			<img class="avatar" src="../public/assets/layout/images/default-avatar.jpg" alt="" />
		</div>
		<button class="p-link layout-profile-link perfil-botao" @click="onClick">
			<div class="p-grid">
				<div class="p-col-8 p-offset-2">
					<span class="username"> {{userName? userName : 'USER TESTE'}}</span>
					<i class="pi pi-fw pi-cog"></i>
				</div>
			</div>
		</button>
        <transition name="layout-submenu-wrapper">
            <ul v-show="expanded">
                <!-- <router-link to="/portalservidor/servidor/dadosPessoais" class="p-link"><li><button class="p-link"><i class="pi pi-fw pi-user"></i><span>Perfil</span></button></li></router-link> -->
                <li><button class="p-link" @click="trocarSenha()"><i class="pi pi-fw pi-key"></i><span>Alterar Senha</span></button></li>
                <li><button class="p-link" @click="logout()"><i class="pi pi-fw pi-power-off"></i><span>Sair</span></button></li>
            </ul>
        </transition>	
	</div>
	
</template>

<script>
	import { mapState } from 'vuex'
	import {baseApiUrl} from '@/config/global'
	export default {
		data: function(){
			return {
				expanded: false
			}
		},		
		props: {
			ontrocarSenha: {
				// Evento disparado para enviar link de ativação
				type: Function
			}
		},
		methods: {
			// ...mapActions(['refreshToken','logarUsuario']),
			onClick(event){
				this.expanded = !this.expanded;
				event.preventDefault();
			},
			logout(){ 
				
				this.$http.delete(`${baseApiUrl}/sessions/logout`).then(() =>{
					if(process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS!='false'){  
						this.$recaptchaInstance.showBadge()
					}
					this.$store.dispatch('logoutUsuario',this)
					if(this.$route.name!='auth'){
						this.$router.push({name:'auth'})
					}
				})

			},
			refresh(){ 
				this.$store.dispatch('refreshToken',this)
			},
			trocarSenha(){ 			
				this.ontrocarSenha()
			},
			fechaMenuProfile(){ 			
				this.expanded = !this.expanded;
			}
		},
		computed: {
			...mapState(['userName'])

		}
	}
</script>
<style scoped>
	.avatar{
		border-radius: 50%;
		width: 50px;
	}
	.perfil-botao{
		text-align: center;
		min-width: 95%;
	}
</style>